module.exports = __webpack_public_path__ + "img/base_bg2.851c036b.jpg";